// extracted by mini-css-extract-plugin
module.exports = {"postLink":"PostLink-module--post-link--1-2R3","postLink__image":"PostLink-module--post-link__image--uORh6","postLink__details":"PostLink-module--post-link__details--30Pj1"};